import type { TypographyTone } from 'aos-ds/src/typography/tones'
import { Typography } from 'aos-ds/src/typography/Typography'
import type { TypographyVariant } from 'aos-ds/src/typography/variants'
import React from 'react'
import { View } from 'react-native'

import { ArrivalsIcon, DeparturesIcon } from '../../icons/line'
import { twMerge } from '../../tailwind/merge'
import { nativeSingleLine } from '../../webOnly'
import { Icon } from '../icon'

export const PUNCTUALITY_DIRECTIONS = ['departures', 'arrivals'] as const

export type PunctualityDirectionKey = (typeof PUNCTUALITY_DIRECTIONS)[number]

const GLYPHS = { departures: DeparturesIcon, arrivals: ArrivalsIcon } as const

export const DIRECTION_LABEL_TEXT_VARIANT: TypographyVariant = 'p1-regular'
export const DIRECTION_LABEL_TONE: TypographyTone = 'default'

export type PunctualityDirectionLabelProps = {
    direction: PunctualityDirectionKey
    label: string
    className?: string
    testID?: string
}

/**
 * Figma `Widget/Punctuality/DirectionLabel` (18629:463128): the direction glyph
 * and its name in capitals, P1 Regular, `small-compact/s` apart. The ink, the gap
 * and the text style are asserted against the composed contract.
 */
export const PunctualityDirectionLabel = ({
    direction,
    label,
    className,
    testID = 'punctuality-direction-label',
}: PunctualityDirectionLabelProps) => (
    <View className={twMerge('flex-row items-center gap-s', className)} testID={testID}>
        <Icon as={GLYPHS[direction]} size='xl' className='text-content-default' />
        <Typography
            variant={DIRECTION_LABEL_TEXT_VARIANT}
            tone={DIRECTION_LABEL_TONE}
            className='shrink-0 whitespace-nowrap uppercase'
            numberOfLines={nativeSingleLine()}
            testID={`${testID}-text`}
        >
            {label}
        </Typography>
    </View>
)

PunctualityDirectionLabel.displayName = 'PunctualityDirectionLabel'
